import { ArrowLeftEndOnRectangleIcon } from "@heroicons/react/24/outline";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

export const LogoutButton = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  return (
    <button
      onClick={() => {
        logout();
        navigate("/");
      }}
      className="flex w-full items-center gap-x-2 rounded-md px-6 py-3 text-sm/6 font-semibold text-red-500 hover:bg-red-50 hover:text-red-600"
    >
      <ArrowLeftEndOnRectangleIcon className="h-5 w-5 text-red-500" />
      Cerrar sesión
    </button>
  );
};
